<div *ngIf="!isLoading else loading">


  <voxel-accordion-group [expandOne]="accordionGroupExpandOne">

    <voxel-accordion [isOpened]="true" [accordionTitle]="CONTENT_BOUNDS?.caption_main" [description]="CONTENT_BOUNDS?.caption_contacts">

      <form>
        
        <div class="voxel-row-4" [formGroup]="contactPrimary">
          <div class="voxel-col-2" *ngIf="!isNaturalPerson">
            <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.names; let control;" [label]="control?.label"
              [msgErr]="(getMessageError(contactPrimary, control, contactPrimary.get(control?.formControlName)?.errors) | async) || control?.msgErr">
              <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.names.formControlName}}"
                placeholder="{{CONTENT_BOUNDS?.contact_fields.names.description}}" minlength="2"
                [maxlength]="CONTENT_BOUNDS?.nameLength" required/>
            </voxel-form-field>
          </div>
          <div class="voxel-col-2" *ngIf="!isNaturalPerson">
            <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.surnames; let control;" [label]="control?.label"
              [msgErr]="(getMessageError(contactPrimary, control, contactPrimary.get(control?.formControlName)?.errors) | async) || control?.msgErr">
              <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.surnames.formControlName}}"
                placeholder="{{CONTENT_BOUNDS?.contact_fields.surnames.description}}" minlength="2"
                [maxlength]="CONTENT_BOUNDS?.nameLength" required/>
            </voxel-form-field>
          </div>
          <div class="voxel-col-2">
            <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.phone_1; let control;" [label]="control?.label"
              [msgErr]="(getMessageError(contactPrimary, control, contactPrimary.get(control?.formControlName)?.errors) | async) || control?.msgErr">
              <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.phone_1.formControlName}}"
                placeholder="{{CONTENT_BOUNDS?.contact_fields.phone_1.description}}" minlength="7" maxlength="10" />
            </voxel-form-field>
          </div>
  
          <div class="voxel-col-2">
            <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields?.email; let control" [label]="control?.label"
              [msgErr]="(getMessageError(contactPrimary, control, contactPrimary.get(control?.formControlName)?.errors) | async) || control?.msgErr">
              <input voxelInput [formControlName]="CONTENT_BOUNDS?.contact_fields.email.formControlName"
                [placeholder]="control?.description" class="voxel-col-2" [pattern]="control?.format" />
            </voxel-form-field>
          </div>
        </div>

        <ng-container *ngIf="isVisible('additional_contact')">
          <h4 class="subtitle">Datos de contacto adicional (Opcional)</h4>

          <div class="voxel-row-4" [formGroup]="contactAdditional">
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.names; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(contactAdditional, control, contactAdditional.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.names.formControlName}}"
                  placeholder="{{CONTENT_BOUNDS?.contact_fields.names.description}}" minlength="2"
                  [maxlength]="CONTENT_BOUNDS?.nameLength" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.surnames; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(contactAdditional, control, contactAdditional.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.surnames.formControlName}}"
                  placeholder="{{CONTENT_BOUNDS?.contact_fields.surnames.description}}" minlength="2"
                  [maxlength]="CONTENT_BOUNDS?.nameLength" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields.phone_1; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(contactAdditional, control, contactAdditional.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input voxelInput formControlName="{{CONTENT_BOUNDS?.contact_fields.phone_1.formControlName}}"
                  placeholder="{{CONTENT_BOUNDS?.contact_fields.phone_1.description}}" minlength="7" maxlength="10" />
              </voxel-form-field>
            </div>
    
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="CONTENT_BOUNDS?.contact_fields?.email; let control" [label]="control?.label"
                [msgErr]="(getMessageError(contactAdditional, control, contactAdditional.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input voxelInput [formControlName]="CONTENT_BOUNDS?.contact_fields.email.formControlName"
                  [placeholder]="control?.description" class="voxel-col-2" [pattern]="control?.format" />
              </voxel-form-field>
            </div>
          </div>
        </ng-container>
        
      </form>


    </voxel-accordion>

    <voxel-accordion [isOpened]="!accordionGroupExpandOne" [accordionTitle]="section?.caption" [description]="section?.caption_subtitle"
      *ngIf="isVisible('advisor_visible') && isVisible('assigned_advisor') && CONTENT_BOUNDS?.assigned_advisor; let section">
      <div class="section">

        <form [formGroup]="form">
          <div class="voxel-row-4">
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="section?.CA_Names; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="section?.CA_Names?.description" voxelInput
                  [formControlName]="section?.CA_Names?.formControlName" class="voxel-col-2" minlength="2"
                  maxlength="150" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="section?.CA_Email; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="control?.description" voxelInput formControlName="{{control?.formControlName}}"
                  class="voxel-col-2" minlength="5" maxlength="30" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="section?.CA_Phone; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="control?.description" voxelInput formControlName="{{control?.formControlName}}"
                  class="voxel-col-2" minlength="7" maxlength="10" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="section?.CA_Code; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="control?.description" voxelInput formControlName="{{control?.formControlName}}"
                  class="voxel-col-2" minlength="2" maxlength="25" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="section?.CA_CodeProduct; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="control?.description" voxelInput formControlName="{{control?.formControlName}}"
                  class="voxel-col-2" maxlength="10" />
              </voxel-form-field>
            </div>
          </div>
        </form>
      </div>
    </voxel-accordion>

    <voxel-accordion [isOpened]="!accordionGroupExpandOne" [accordionTitle]="section?.caption" [description]="section?.caption_subtitle"
      *ngIf="isVisible('specialized_advisor') && CONTENT_BOUNDS?.specialized_advisor; let section">

      <div class="section">
        <form [formGroup]="form">
          <div class="voxel-row-4" *ngIf="section; let controls">
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="controls?.SA_Names; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="controls?.SA_Names?.description" voxelInput
                  [formControlName]="controls?.SA_Names?.formControlName" class="voxel-col-2" minlength=2
                  maxlength="40" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="controls?.SA_Email; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="controls?.SA_Email?.description" voxelInput
                  [formControlName]="controls?.SA_Email?.formControlName" class="voxel-col-2" />
              </voxel-form-field>
            </div>
            <div class="voxel-col-2">
              <voxel-form-field *ngIf="controls?.SA_Phone; let control;" [label]="control?.label"
                [msgErr]="(getMessageError(form, control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                <input [placeholder]="controls?.SA_Phone?.description" voxelInput
                  [formControlName]="controls?.SA_Phone?.formControlName" class="voxel-col-2" minlength="7"
                  maxlength="10" />
              </voxel-form-field>
            </div>
          </div>
        </form>
      </div>
    </voxel-accordion>

  </voxel-accordion-group>


  <voxel-dialog [dialogOrigin]="overlayModalDialog" [id]="'dialog-a'"
    [buttonLabels]=" { action1:'Cancelar' , action2: 'Aceptar' } " [dialogIsOpen]="modalAShow"
    (dialogClose)="close($event, 'delete')">
    <p>¿Estás seguro de eliminar el contacto?</p>

    <div voxelDialogFooter>
      <button voxelButtonContextual (click)="close({type:'action1'}, 'delete')">
        Cancelar
      </button>
      <button voxelButtonContextual (click)="close({type:'action2'}, 'delete')">
        Aceptar
      </button>
    </div>

  </voxel-dialog>

</div>

<ng-template #loading>
  <voxel-loading-circle class="loading voxel-col-12" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
</ng-template>